import { getField, Locales } from "@simplyk/common";

import { TicketingPrizeOutput, TicketingWithPrizes } from "../types";

export const getVisibleTicketingPrizes = (ticketing: TicketingWithPrizes, locale: Locales): TicketingPrizeOutput[] =>
  (ticketing.prizes ?? [])
    .filter((prize) => !prize.isHidden)
    .map(({ prizeFields, ...prize }) => {
      const prizeField = getField(prizeFields, locale);
      return { ...prize, title: prizeField?.title ?? "", description: prizeField?.description ?? null };
    });
